import React, { cloneElement, useState, useEffect } from "react";
import { NavLink, useRouteMatch, useLocation } from "react-router-dom";
import { mainNav } from "./navigation";
import { useDispatch, useSelector } from "react-redux";
import { toggleNav, setSubcategory, openMobile } from "../actions";
import Dropdown from "./dropdown";
import { SubscriptionLock, Modal } from "components";
import { Subscription } from "./icons/icons";
import StoreDropdown from "./shop-dropdown.js";
import { Minimize } from "./icons/icons/icons";
import { Tooltip } from "@paylixecommerce/shared/components";

import "./index.scss";


export const Sidebar = ({ billing, isMobile }) => {

	const isOpen = useSelector(({nav}) => nav.open);
	const isOpenMenu = useSelector(({ nav }) => nav.mobile);
	const dark = useSelector(({theme}) => theme.globalTheme === "dark");
	const bannerHeight = useSelector(({ nav }) => nav.bannerHeight);
	const { profile } = useSelector(({auth}) => auth);
	const dispatch = useDispatch();
	const { pathname } = useLocation();
	const isAppSumoUser = profile && profile.appsumo_tier_id;

	const [appealModal, showAppealModal] = useState(false);

	useEffect(() => {

		mainNav(pathname).map(({ url, name, children }) => {
			if (children && children.length) {
				if (url) {
					dispatch(setSubcategory(name));
				}
			}

			return null
		});

	}, [pathname]);

	useEffect(() => {
		if(isOpenMenu && isMobile) {
			dispatch(openMobile(!isOpenMenu));
		}
	}, [isOpen, isMobile, pathname])

	let isActive = (path) => useRouteMatch({ path, exact: true });

	return <>

		<div className={`sidebar-container ${isOpen ? "" : isMobile ? "" : "minimized"} ${isMobile ? 'mobile' : ''}`} style={isMobile ? {} : { top: `${bannerHeight}px + 3.5rem`}}>

			<ul className={`sidebar ${isOpen ? "" : isMobile ? "" :"minimized"}`}>

				{
					isMobile ? null : !isOpen ? <li className="nav-item" onClick={() => dispatch(toggleNav(!isOpen))} id="minimized">
						<a className="nav-link" style={{ transform: "rotate(180deg)" }}>
							<Minimize />
						</a>
					</li> : null
				}

				{mainNav(pathname).map((item, key) => {

					const { name, url, to, icon: Icon, children, id, isNew } = item;

					if (id === "subscription") {

						if(isAppSumoUser) {
							return <li key={key} className="nav-item" id={id}>
								<NavLink className="nav-link" to={to} onClick={() => dispatch(setSubcategory(null))} exact>
									<Subscription dark={dark} active={pathname.includes("subscription")} />
									<span className={isNew && isOpen ? 'd-flex text-nowrap' : ''}>
										{name}
									</span>
								</NavLink>
							</li>
						} else {
							return null
						}

					}

					if (children && children.length) {
						return <Dropdown billing={billing} mobile={isMobile} item={item} key={key} showAppealModal={() => showAppealModal(true)}/>
					}

					return <li key={key} className="nav-item" id={id}>
						<NavLink className="nav-link" to={to} onClick={() => dispatch(setSubcategory(null))} exact>
							{cloneElement(Icon, { active: isActive(url), dark })}
							<span className={isNew && isOpen ? 'sidebar-new-badge' : ''}>
								{name}
								{isNew && isOpen ? <span className="badge badge-paylixecommerce" style={{ fontSize: 12, lineHeight: "normal", border: `1px solid ${dark ? "var(--purple6)" : "#DBD8FC"}` }}>New</span> : ''}
							</span>
						</NavLink>
					</li>

				})}

			</ul>

			<StoreDropdown />

		</div>

		<Tooltip name="beta" tooltipText={"This feature is currently in BETA. You can use, but it might present bugs. Should you find any, please report them at roadmap.paylix.gg/bugs"} isOutside />
		<Tooltip name="new" isOutside />

		<Modal open={appealModal} closeModal={() => showAppealModal(false)}>
			<SubscriptionLock isAppeal />
		</Modal>
	</>
}

// @TODO tooltip
export default Sidebar;
